import { Card, DataList, DataListColumnTitle, DataListHeader, DataListItem, Loading, useShowQuery } from "@dgs/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { deletionRequestService } from "../shared/api/deletionRequestService";
import { IDeletionRequestUpdateResource } from "../shared/types";

export const DeletionRequestViewPage = () => {
	const { t } = useTranslation();
	const { id = "" } = useParams<"id">();
	const { data, isLoading } = useShowQuery(id, deletionRequestService);

	if (isLoading || !data) {
		return <Loading />;
	}

	return (
		<Card>
			<DataListHeader heading={t(`Processed deletion requests for {{email}}`, { email: data.email })} loading={false} />
			<DataList empty={t("No data available.")} isEmpty={!data.applications.length}>
				<DataListColumnTitle>{t("Subdomain")}</DataListColumnTitle>
				<DataListColumnTitle>{t("Status")}</DataListColumnTitle>
				<DataListColumnTitle>{t("Error message")}</DataListColumnTitle>
				{(data as IDeletionRequestUpdateResource).applications.map((row) => (
					<React.Fragment key={row.id}>
						<DataListItem>{row.subdomain}</DataListItem>
						<DataListItem>{t(row.status)}</DataListItem>
						<DataListItem>{row.errorMessage}</DataListItem>
					</React.Fragment>
				))}
			</DataList>
		</Card>
	);
};
